export default __webpack_public_path__ + "static/media/poppins-latin.woff2";